<template>
  <m-card908 class="content-card-908s-wrapper" :image="content.thumbnail" :alt="content.title">
    <template #p-1>
      <h5>{{ content.title }}</h5>
      <span v-for="keyword in content.keywords">{{ keyword.keyword }}</span>
    </template>
    <template #p-2>
      <p v-html="content.body"></p>
    </template>
    <template #p-3>
      <div>
        <m-icon class="d-inline-block ml-1" icon="geo-alt"/>
        <span class="d-inline-block" v-html="content.abstraction"> </span>
      </div>
    </template>
  </m-card908>
</template>

<script>
import {CardComputed} from "./CardComputed";
import mCard908 from "../../Cards/Card908";
import mA from '../../Tags/A'
import mIcon from '../../Icons/Icon.vue'

export default {
  name: "ContentCard908",
  components: {mCard908, mA, mIcon},
  props: {
    content: {}
  },
  computed: {
    ...CardComputed
  }
}
</script>

<style scoped>
.content-card-908s-wrapper :deep(.blockquote-footer){
  position: absolute;
  bottom: 0;
}
</style>